import { createSelector } from '@ngrx/store';
import * as user from '../reducers/user/user.reducer';

export const getAuthenticationError = createSelector(
  user.getUserState,
  user.getAuthenticationError
);

export const isAuthenticated = createSelector(
  user.getUserState,
  user.isAuthenticated
);
export const getCurrentUser = createSelector(
  user.getUserState,
  user.getCurrentUser
);

export const getAuthenticationLoading = createSelector(
  user.getUserState,
  user.getAuthenticationLoading
);

export const getAuthToken = createSelector(
  user.getUserState,
  user.getAuthToken
);
